/** Role capability copy shown via the Role (i) info icon on user forms. */
export const ROLE_DESCRIPTIONS = {
  corporate_admin:
    'Full access to all users, their settings, branches, and departments across the corporate.',
  admin:
    'Full access to all users, their settings, branches, and departments across the corporate.',
  branch_admin:
    'Similar to Corporate Admin, but limited to the specific branch and its departments.',
  department_admin:
    'Access to users, their settings, and all sub-departments within the department.',
  sub_department_admin:
    'Access to users and their settings for the specific sub-department only.',
  user: 'Standard user access within the assigned organizational scope.',
};

export const ROLE_INFO_SUMMARY =
  'Corporate Admin: all users, settings, branches & departments. Branch Admin: same within the branch. Department Admin: users, settings & sub-departments. Sub Department Admin: users & settings for that sub-department only.';

export const ACCESS_SCOPE_INFO = {
  limited: 'The user can see only the records they created or that are assigned to them.',
  full: 'The user can see every record in the unit they are registered in: the sub-department if they have one, otherwise the department, otherwise the branch.',
};

export function formatRoleLabel(roleName) {
  if (!roleName) return 'N/A';
  return String(roleName)
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function getRoleDescription(roleName) {
  if (!roleName) return ROLE_INFO_SUMMARY;
  const key = String(roleName).toLowerCase().replace(/\s+/g, '_').trim();
  return ROLE_DESCRIPTIONS[key] || ROLE_INFO_SUMMARY;
}
